import Transformer from './../transformer'
import HighwaySectionTransformer from './highwaySection'

export default class HighwayTollboothTransformer extends Transformer {
  static fetch(tollbooth) {
    const { highway_section } = tollbooth
    const highwaySection = HighwaySectionTransformer.fetch(tollbooth.highway_section)
    return {
      id: tollbooth.id,
      name: tollbooth.name,
      highwaySection,

      // s
      // s
      tollboothAttendantName: tollbooth.attendant.name + ' ' + tollbooth.attendant.last_name,
      tollboothAttendantId: tollbooth.attendant.attendant_id,
      ...tollbooth,
      //TODO: need client
    }
  }
  // TODO: Pending add client data 
  static send(tollbooth) {
    return {
      id: tollbooth.id,
      name: tollbooth.name,
      is_active: true,
      attendant: tollbooth.tollboothAttendantId,
      highway_section: tollbooth.highwaySectionId,
      state: tollbooth.stateId,
      municipality: tollbooth.municipalityId,
      highway: tollbooth.highwayId,
    }
  }
}



// WEBPACK FOOTER //
// ./src/transformers/catalog/highwayFullTollbooth.js